<template>
  <div v-if="!!activeFilterDetail" class="q-mt-md">
    <div class="row inline no-wrap full-width justify-start q-mb-md">
      <span class="text-h6 text-grey-10">{{ activeFilterDetail.filterName }}</span>
    </div>
    <div class="column full-width justify-start q-pl-sm q-mt-md">
      <span class="text-bold text-grey-9">Accounts</span>
    </div>
    <div class="column full-width">
      <ItemExpandable
        v-if="activeFilterDetail.accountId.trim().length > 0"
        :defaultOpened="false"
        :label="$t('Account Id(s)')"
        group="formsGroup"
        class="full-width q-my-md"
      >
        <CRow class="full-width q-px-xl q-my-md">
          <span class="text-caption text-grey-7 q-pl-sm q-mt-sm">{{
            activeFilterDetail.accountId.split(',').join(' , ')
          }}</span>
        </CRow>
      </ItemExpandable>
      <ItemExpandable
        v-for="(filter, filterIndex) in filters"
        :key="filterIndex + 'filter-row'"
        :defaultOpened="false"
        :label="`${$t('OR')} (${$t(' Entry ')} ${filterIndex + 1})`"
        group="formsGroup"
        class="full-width q-my-md"
      >
        <!-- <span class="text-grey-9 text-h5">Form {{ filterIndex + 1 }}</span> -->
        <CRow class="full-width q-px-xl q-my-md">
          <CCol
            col="6"
            v-for="(filterVal, filterKey, filterKeyIndex) in filter"
            :key="`filter-label-val-${filterKey}${filterKeyIndex}`"
          >
            <LabelValue
              class="item q-my-sm"
              :label="$t(constants[filterKey] || filterKey)"
              :value="mapFilterVal(filterVal)"
            />
          </CCol>
        </CRow>
      </ItemExpandable>
    </div>
    <div
      v-if="tagFilters.length > 0"
      class="row inline no-wrap full-width justify-start q-pl-sm q-mt-md"
    >
      <span class=" text-bold text-grey-9">Tags</span>
    </div>
    <div class="column full-width">
      <ItemExpandable
        v-for="(filter, filterIndex) in tagFilters"
        :key="filterIndex + 'filter-tag-row'"
        :defaultOpened="false"
        :label="`${$t('OR')} (${$t(' Entry ')} ${filterIndex + 1})`"
        group="formsGroup"
        class="full-width q-my-md"
      >
        <!-- <span class="text-grey-9 text-h5">Form {{ filterIndex + 1 }}</span> -->
        <CRow class="full-width q-px-xl q-my-md">
          <CCol
            col="6"
            v-for="(filterVal, filterKey, filterKeyIndex) in filter"
            :key="`filter-label-val-${filterKey}${filterKeyIndex}`"
          >
            <LabelValue
              class="item q-my-sm"
              :label="$t(constants[filterKey] || filterKey)"
              :value="mapFilterVal(filterVal)"
            />
          </CCol>
        </CRow>
      </ItemExpandable>
    </div>
  </div>
</template>

<script>
import CSection from '@/components/uikit/CSection';
import CRow from '@alphauslabs/alphaus-design-system/src/components/Row';
import CCol from '@alphauslabs/alphaus-design-system/src/components/Col';
import LabelValue from '@alphauslabs/alphaus-design-system/src/components/LabelValue';
import ItemExpandable from '@design-system/components/ItemExpandable';
import CButton from '@/components/uikit/CButton';
const messages = {
  en: {
    'Basic setting': 'Basic Settings',
    'Billing group name': 'Billing Group Name',
    'Billing group ID': 'Billing Group ID',
    Currency: 'Currency',
    'Calculation type': 'Calculation Type',
    'True Unblended': 'True Unblended',
    Unblended: 'Unblended',
    'Exchange rate type': 'Exchange Rate Level',
    'Billing title': 'Billing Title',
    'Invoice language': 'Invoice Language',
    'Project code': 'Project Code',
    'Company name': 'Company Name',
    Addressee: 'Addressee',
    'Postal code': 'Postal Code',
    'Company address': 'Company Address',
    'Phone number': 'Phone Number',
    Remarks: 'Remarks',
    payer: 'Payer',
    billing_group: 'Billing Group',
  },
  ja: {
    'Basic setting': '基本設定',
    'Billing group name': '請求グループ名',
    'Billing group ID': '請求グループID',
    Currency: '支払いタイプ',
    'Calculation type': '計算方法',
    'True Unblended': 'True Unblended',
    Unblended: 'Unblended',
    'Exchange rate type': '為替レートタイプ',
    'Billing title': '請求タイトル',
    'Invoice language': '請求書の言語',
    'Project code': 'プロジェクトコード',
    'Company name': '企業名',
    Addressee: '宛名',
    'Postal code': '郵便番号',
    'Company address': '会社住所',
    'Phone number': '電話番号',
    Remarks: '備考欄',
    payer: '支払いアカウント',
    billing_group: '請求グループ',
  },
};
export default {
  name: 'FilterDetails',
  components: { CSection, ItemExpandable, CRow, CCol, CButton, LabelValue },
  i18n: {
    messages: messages,
  },
  props: ['activeFilterId'],
  computed: {
    constants() {
      return {
        instanceType: 'Instance Type',
        invoiceId: 'Invoice Id',
        operation: 'Operation',
        productCode: 'Product Code',
        region: 'Region',
        serviceCode: 'Service Code',
        usageType: 'Usage Type',
        zone: 'Zone',
      };
    },
    activeFilterDetail() {
      if (this.activeFilterId === 'all') return null;
      return this.$store.getters['reportFilters/getActiveFilterData']({
        vendor: 'aws',
        filterId: this.activeFilterId,
      });
    },
    filters() {
      if (!this.activeFilterId) return [];
      const filterEmptyCategories = obj =>
        Object.fromEntries(Object.entries(obj).filter(([, v]) => v !== ''));
      return this.activeFilterDetail.awsOptions.filters.map(filter =>
        filterEmptyCategories(filter.andFilters)
      );
    },
    tagFilters() {
      if (!this.activeFilterId) return [];
      return this.activeFilterDetail.awsOptions.tagFilters.map(filter => filter.andFilters);
    },
  },
  methods: {
    mapFilterVal(val) {
      return val
        .replace('re:', '')
        .split('|')
        .join(',');
    },
  },
};
</script>
